/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });

  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });

  // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  theme.utils = theme.utils || {};
  theme.utils.ConvertStringToHTML = (str) => {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  };

  document.addEventListener('alpine:init', () => {
    Alpine.data('LoadMoreProducts', () => ({
      page: 1,
      page_count: 1,
      delay: 2500,
      flags: {
        loading: false,
        isLastPage: false
      },
      mounted() {
        let am = this;
        am.page_count = parseInt(am.$el.dataset.page_count);

        document.body.onscroll = (e) => {
          let scrollReachedBottom = window.scrollY >= (am.$el.scrollHeight - am.$el.offsetTop);

          if (!scrollReachedBottom) return;
          if (am.flags.loading) return;
          if (am.flags.isLastPage) return;

          // console.log(e);
          Alpine.throttle(() => {
            am.flags.loading = true;
            setTimeout(am.LoadMore.bind(am), am.delay);
          }, 500)();
        }
      },

      LoadMore() {
        am = this;

        am.page += 1;
        am.flags.isLastPage = am.page >= am.page_count;

        (async () => {
          let section_id = am.$el.dataset.sectionId;
          let url  = `${ window.location.pathname }?page=${ am.page }&sections=${ section_id }`;
          // console.log(url);
          let res = await fetch(url).then((res => res.json()));
          // console.log(res);
          let $section = theme.utils.ConvertStringToHTML(res[section_id]);
          let $products = [...$section.querySelectorAll('.product-grid-item')];
          // console.log($section, $products);

          $products.forEach(($product) => {
            am.$el.querySelector('.js-grid').insertAdjacentElement('beforeend', $product);
          });

          am.$el.dataset.page = am.page;
          am.flags.loading = false;
        })();
      }
    }));
  });
})();
